import { render, staticRenderFns } from "./TaxEmailProvideNotice.vue?vue&type=template&id=6c4da4dd&scoped=true"
import script from "./TaxEmailProvideNotice.vue?vue&type=script&lang=js"
export * from "./TaxEmailProvideNotice.vue?vue&type=script&lang=js"
import style0 from "./TaxEmailProvideNotice.vue?vue&type=style&index=0&id=6c4da4dd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4da4dd",
  null
  
)

export default component.exports